import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import BrandMark from "@/components/BrandMark";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "player" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await register(form);
      nav("/app/dashboard");
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#071426] px-4 py-10">
      <div className="w-full max-w-md fade-up">
        <div className="flex justify-center mb-8">
          <BrandMark />
        </div>
        <div className="bg-[#0D2038] border border-[#1F3A5C] rounded-2xl p-7">
          <h1 className="font-heading text-2xl font-bold mb-1">Create your account</h1>
          <p className="text-sm text-[#AAB7C7] mb-6">Start a 14-day free trial</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-medium uppercase tracking-wider text-[#AAB7C7]">Name</label>
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name-input"
                className="mt-1 w-full bg-[#071426] border border-[#1F3A5C] focus:border-[#C7F500] focus:outline-none rounded-lg px-3 py-2.5" />
            </div>
            <div>
              <label className="text-xs font-medium uppercase tracking-wider text-[#AAB7C7]">Email</label>
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email-input"
                className="mt-1 w-full bg-[#071426] border border-[#1F3A5C] focus:border-[#C7F500] focus:outline-none rounded-lg px-3 py-2.5" />
            </div>
            <div>
              <label className="text-xs font-medium uppercase tracking-wider text-[#AAB7C7]">Password</label>
              <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password-input"
                className="mt-1 w-full bg-[#071426] border border-[#1F3A5C] focus:border-[#C7F500] focus:outline-none rounded-lg px-3 py-2.5" />
            </div>
            <div>
              <label className="text-xs font-medium uppercase tracking-wider text-[#AAB7C7]">I want to</label>
              <div className="mt-1 grid grid-cols-2 gap-2">
                <button type="button" onClick={() => setForm({ ...form, role: "player" })} data-testid="role-player-btn"
                  className={`py-2.5 rounded-lg border text-sm font-medium ${form.role === "player" ? "border-[#C7F500] bg-[#C7F500]/10 text-[#C7F500]" : "border-[#1F3A5C] text-[#AAB7C7]"}`}>
                  Join as Player
                </button>
                <button type="button" onClick={() => setForm({ ...form, role: "competition_admin" })} data-testid="role-admin-btn"
                  className={`py-2.5 rounded-lg border text-sm font-medium ${form.role === "competition_admin" ? "border-[#C7F500] bg-[#C7F500]/10 text-[#C7F500]" : "border-[#1F3A5C] text-[#AAB7C7]"}`}>
                  Run a competition
                </button>
              </div>
            </div>
            {err && <div className="text-sm text-red-400" data-testid="register-error">{err}</div>}
            <button type="submit" disabled={busy} data-testid="register-submit-btn"
              className="w-full py-3 rounded-lg bg-[#C7F500] hover:bg-[#D9FF27] disabled:opacity-60 font-semibold transition-colors">
              {busy ? "Creating…" : "Create account"}
            </button>
          </form>
          <div className="mt-6 text-sm text-center text-[#AAB7C7]">
            Already have an account?{" "}
            <Link to="/login" className="text-[#C7F500] hover:underline">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
